import React, { useEffect, useState } from 'react';
import { BrModal } from '@govbr-ds/react-components';
import './AGHUInfoDialog.css';
import { GovBrTable } from 'components';
import { elasticRequests } from 'apiServices/elasticSearchAPI/elasticRequests';

// eslint-disable-next-line react/prop-types
export function AGHUInfoDialog({ open, setModalOpen, data }) {
  const [loading, setLoading] = useState(true);

  const [rows, setRows] = useState([]);
  const handleClose = () => {
    setModalOpen(false);
  };

  function formatDateTime(dateTime) {
    if (!dateTime) return null;

    const date = new Date(dateTime);

    if (isNaN(date.getTime())) return null;

    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }

  function obterResultado(e) {
    const codes = [
      e?._source?.attempt1_code,
      e?._source?.attempt2_code,
      e?._source?.attempt3_code,
    ];

    if (codes.some((code) => code === '200')) {
      return 'resultado de exame obtido do AGHU';
    }

    if (codes.some((code) => code === '000')) {
      return 'sem resposta do AGHU';
    }

    const valores = [
      e?._source?.attempt1_code !== undefined &&
        `${e?._source?.attempt1_code} - ${e?._source?.attempt1_payload}`,
      e?._source?.attempt2_code !== undefined &&
        `${e?._source?.attempt2_code} - ${e?._source?.attempt2_payload}`,
      e?._source?.attempt3_code !== undefined &&
        `${e?._source?.attempt3_code} - ${e?._source?.attempt3_payload}`,
    ].filter(Boolean);

    return valores.length > 0 ? valores.join(', ') : '';
  }

  const header = [
    { display: 'Data/hora ', path: '@timestamp' },
    { display: 'ID do documento', path: 'local_id' },
    { display: 'Itens solicitados', path: 'itens' },
    { display: 'Resposta do AGHU', path: 'code' },
  ];

  useEffect(() => {
    async function fetchReponse() {
      try {
        const ConnectorAuditFilter = [
          { filter: data.localId && `(local_id:"${data.localId}")` },
          { filter: data.cnes && `cnes:"${data.cnes}"` },
        ]
          ?.filter((el) => el.filter)
          ?.map((e) => e.filter)
          ?.join(' AND ');

        const connector_audit = await elasticRequests.Api_AGHU({
          filter: ConnectorAuditFilter,
        });

        const auxResponse = connector_audit?.hits?.hits?.map((e) => ({
          '@timestamp': formatDateTime(e?._source?.['@timestamp']),
          local_id: e?._source?.local_id,
          itens: e?._source?.itens,
          code: obterResultado(e),
        }));

        setRows(auxResponse);
      } catch (err) {
        console.log('AGHUDetails', err);
      } finally {
        setLoading();
      }
    }
    if (data) fetchReponse();
  }, []);

  return (
    <BrModal
      title="Tentativas de obtenção do registro na API de resultados de exame do AGHU"
      isOpen={open}
      showClose
      onClose={handleClose}
    >
      <div style={{ minWidth: '900px', marginTop: '40px' }}>
        {!loading && <GovBrTable header={header} body={rows} />}
      </div>
    </BrModal>
  );
}
